'use client';

import Link from '@eliadmin/core/src/components/link';

import { Button } from '@eliadmin/core/src/components/ui/button';
import { Spinner } from '@eliadmin/core/src/components/ui/spinner';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';

import { FaRegUser } from 'react-icons/fa';
import { ROUTES } from '@eliadmin/core/src/constants/routes';

export const HeaderProfileButton = () => {
  const me = useCustomerStore(s => s.me);
  const isInitialized = useCustomerStore(s => s.isInitialized);

  const isLoggedIn = !!me && isInitialized;

  if (!isInitialized) {
    return (
      <Button size={'icon'} variant={'outline'} aria-label="Načítava sa používateľský účet">
        <Spinner />
      </Button>
    );
  }

  if (!isLoggedIn && isInitialized) {
    return (
      <Button asChild size={'icon'} variant={'outline'}>
        <Link prefetch={false} href={ROUTES.REGISTER()} aria-label="Registrácia">
          <FaRegUser size={20} />
        </Link>
      </Button>
    );
  }

  return (
    <Button asChild size={'icon'} variant={'outline'}>
      <Link prefetch={false} href={ROUTES.PROFILE()} aria-label="Môj profil">
        <FaRegUser size={20} />
      </Link>
    </Button>
  );
};
